//import Libraries
import React, {Component} from 'react';

//import Components
// import NaverMap, {Marker} from 'react-naver-map';
import DaumMap from 'daum-maps-react'

//import Styles
import './Map.css';

// const CLIENT_ID = "TnH8y_0wQk7bix6iAsUM";
const myKey = "80e9ce18225025ecb92e41a2d2806c13";

class Map extends Component{
    state = {
        lat: this.props.data.lat,
        lng: this.props.data.lng
    }

    customRender = (element, daum) => {

        daum.maps.load(_ => {
 
            const map = new daum.maps.Map(element, {
                center: new daum.maps.LatLng(this.state.lat, this.state.lng),
                level: 6
            })
    
            const marker = new daum.maps.Marker({
                position: new daum.maps.LatLng(this.state.lat, this.state.lng)
            })
 
            marker.setMap(map)
 
        })
 
    }
    
    render(){

        return (
            <DaumMap
                apiKey={myKey}
                mapId={ this.props.data.name.en }
                render= { this.customRender }
            />
        );
    }
}

export default Map;

// Map.PropTypes


// WEBPACK FOOTER //
// ./src/components/Map/Map.js